import { message, Tooltip } from 'antd'
import React from 'react'
import './index.less'

export default function Color(props) {
  const { fucaiData } = props
  // 点击复制颜色值的回调
  const handleCopyColor = function (colorName: string) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(colorName)
    } else {
      const textarea = document.createElement('textarea')
      document.body.appendChild(textarea)
      // 隐藏此输入框
      textarea.style.position = 'fixed'
      textarea.style.top = '10px'
      // 赋值
      textarea.value = colorName
      // 选中
      textarea.select()
      // 复制
      document.execCommand('copy', true)
      // 移除输入框
      document.body.removeChild(textarea)
    }
    message.success('复制成功！' + colorName)
  }
  return (
    <div className='fucai-contents'>
      <div className='fucai-colors'>
        {fucaiData.map((item) => {
          return (
            <Tooltip title={'点击复制：' + item.name} key={item.name}>
              <div className='fucai-eachColor' key={item.name} style={{ width: item.percentage }}>
                <div
                  onClick={() => handleCopyColor(item.color)}
                  className='fucai-eachColor-percentage'
                  style={{
                    backgroundColor: item.color,
                    color: 'white'
                  }}
                >
                  {item.percentage}
                </div>
              </div>
            </Tooltip>
          )
        })}
      </div>
    </div>
  )
}
